import styled from "styled-components"

export const Container = styled.div`
  margin: 2rem 0 3rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
`

export const HighlightItem = styled.div`
  width: 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`

export const FeatureHighLightImage = styled.img`
  width: ${({ width }) => width || "2.4rem"};
  height: ${({ height }) => height || "2.4rem"};
`

export const Text = styled.p`
  margin: 0;
  color: #374151;
  font-size: 1.4rem;
  text-align: center;
`
